import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

// Pages
import Home from './pages/Home';
import OverOns from './pages/OverOns';
import HoeWerktHet from './pages/HoeWerktHet';
import CocktailMenu from './pages/CocktailMenu';
import Galerij from './pages/Galerij';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import Offerte from './pages/Offerte';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';

// Layout Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ProtectedRoute from './components/ProtectedRoute';

// Context
import { CmsProvider } from './context/CmsContext';
import { AuthProvider } from './context/AuthContext';

const PublicLayout = ({ children }) => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  return (
    <>
      {!isAdmin && <Navbar />}
      {children}
      {!isAdmin && <Footer />}
    </>
  );
};

function App() {
  return (
    <CmsProvider>
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <div className="App">
            <PublicLayout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/over-ons" element={<OverOns />} />
                <Route path="/hoe-werkt-het" element={<HoeWerktHet />} />
                <Route path="/menu" element={<CocktailMenu />} />
                <Route path="/galerij" element={<Galerij />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/offerte" element={<Offerte />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <AdminDashboard />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </PublicLayout>
          </div>
        </Router>
      </AuthProvider>
    </CmsProvider>
  );
}

export default App;
